import * as React from 'react'
import { PaymentContext } from '../providers/payment'

export default function usePayment() {
    return React.useContext(PaymentContext)
}
